<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Performance Mensal Estabelecimento</h5>
      </div>
    </div>
    <div class="row">
      <list-receivables class="mb-4" />
    </div>
  </div>
</template>
<script>
import ListReceivables from "./lista";

export default {
  components: {
    ListReceivables
  },
  methods: {
  },
  mounted() {}
};
</script>

<style lang="scss" module>
// @import "./style.module.scss";
</style>